<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group slot-scope="{ valid, errors }" v-bind="$attrs">
      <template #label>
        <label>
          {{ $attrs.label }}
          <span v-if="$attrs.required || rules.includes('required')" class="text-danger font-bold"
            >*</span
          >
        </label>
      </template>
      <b-form-textarea
        v-model="innerValue"
        v-bind="$attrs"
        :state="errors[0] ? false : rules && rules.includes('required') && valid ? true : null"
        rows="3"
        max-rows="6"
      >
      </b-form-textarea>
      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { BFormGroup, BFormTextarea, BFormInvalidFeedback } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormTextarea,
    BFormInvalidFeedback,
  },
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
